import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { WebView } from 'react-native-webview';
import client from '@sart/client'
import { useContent } from '@sart/content'
import { Title, Space } from '@sart/components'
import { adaptive, colors } from '@sart/styles'
import { CompanyIcon } from '@sart/icons'
import CheckoutProcessing from './CheckoutProcessing'
import CheckoutLoading from './CheckoutLoading'
import AppConfig from '../Configuration';

class CheckoutHostedPayment extends React.Component {
  constructor(props) {
    super(props)
    this.state = { link: null }
  }

  async componentDidMount() {
    const { navigation, route } = this.props

    const basketRefId = route.params?.basketRefId
    const gatewayURL = route.params?.gatewayURL

    this.setState({
      link: gatewayURL
    })

    await this.checkPaymentStatus(basketRefId)
  }

  async checkPaymentStatus(basketRefId) {
    const { navigation, route } = this.props
    let order = await client.getOrders(basketRefId, AppConfig.pollingMaxRetries);
    // this.setState({
    //   processing: true
    // })

    // order = await orderHelper.pollOrderForStatus(client.cache.customerId, order.orderId)
    if (!order || order.status === 'failed') {
      navigation.navigate('Checkout', {
        failedOrder: order
      })
    } else {
      const productsPurchased = route.params?.productsPurchased

      navigation.navigate('CheckoutProcessing', { order, productsPurchased })
    }
    // if (order && order.status === 'successful') {
    //   await client.loadBalancesAndInvoices()
    //   navigation.navigate('Confirmation', {
    //     productsPurchased,
    //     order
    //   })
    // } else if (order && order.status === 'failed') {
    //   setData({ loading: false, error: content.errors.failedPurchase })
    // }
  }

  render() {
    const { link } = this.state
		const content = useContent()

    // if (!link) return (<CheckoutLoading />)
    // if (processing) return (<CheckoutProcessing />)

    return (
      <View style={styles.container}>
        {/*<WebView
          source={{ uri: link }}
          style={styles.webview}
          keyboardDisplayRequiresUserAction={false}
          hideKeyboardAccessoryView={true}
				/> */}
        <Space height={24} />
        <CompanyIcon width={220} height={181} color={colors.white} />
        <Space height={2 * 24} />

        <Title style={styles.title}>
          {content.common.processing}
        </Title>

      </View>
    )
  }
}

const styles = StyleSheet.create({
  /*ontainer: {
    paddingTop: 24,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor:colors.white
  },
  webview: {
    // marginTop: 10,
    maxHeight: 800,
    ...adaptive.webViewWidth,
    flex: 1
  } */
  container: {
    flex: 1,
    backgroundColor: colors.srGreen,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.white,
    fontSize: 24
  }
})

export default CheckoutHostedPayment
